import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=d67d1964&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=d67d1964&prod&lang=scss&scoped=true&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=d67d1964&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67d1964",
  null
  
)

export default component.exports